import React from 'react'

function TermsAndConditions() {
    return (
        <>
            <div className='main-container'>
                <h1 className='home-container' style={{ color: 'white' }}>
                    Termeni și Condiții
                </h1>

                <strong style={{ color: 'white', background: '#696969', padding: '3px', borderRadius: '5px', letterSpacing: '0.1rem' }}> 1. Acceptarea termenilor</strong>
                <p style={{ color: 'white' }}>Prin utilizarea acestui site, sunteți de acord să respectați acești Termeni și Condiții. Dacă nu sunteți de acord cu aceștia, vă rugăm să nu utilizați site-ul.
                </p>

                <strong style={{ color: 'white', background: '#696969', padding: '3px', borderRadius: '5px', letterSpacing: '0.1rem' }}> 2. Scopul site-ului</strong>
                <p style={{ color: 'white' }}>Acest site oferă informații și resurse educaționale pentru cei care doresc să învețe informatică (programare în C++).</p>

                <strong style={{ color: 'white', background: '#696969', padding: '3px', borderRadius: '5px', letterSpacing: '0.1rem' }}> 3. Înregistrare și conturi</strong>
                <p style={{ color: 'white' }}>Dacă vă creați un cont pe site:<br />

                    Sunteți responsabil pentru păstrarea confidențialității datelor de autentificare.<br />

                    Nu aveți voie să creați conturi false sau să furnizați informații înșelătoare.</p>

                <strong style={{ color: 'white', background: '#696969', padding: '3px', borderRadius: '5px', letterSpacing: '0.1rem' }}> 4. Drepturile de proprietate intelectuală</strong>
                <p style={{ color: 'white' }}>Tot conținutul de pe site (texte, imagini, materiale video, logo-uri) este proprietatea <strong>CodersRo</strong> și este protejat prin lege.<br /> Nu este permisă copierea sau redistribuirea fără acordul nostru scris.
                </p>

                <strong style={{ color: 'white', background: '#696969', padding: '3px', borderRadius: '5px', letterSpacing: '0.1rem' }}> 5. Limitarea răspunderii</strong>
                <p style={{ color: 'white' }}>Nu garantăm că materialele oferite sunt 100% fără erori sau că vor aduce rezultate specifice. Utilizarea site-ului se face pe propriul risc.</p>

                <strong style={{ color: 'white', background: '#696969', padding: '3px', borderRadius: '5px', letterSpacing: '0.1rem' }}> 6. Modificări ale Termenilor</strong>
                <p style={{ color: 'white' }}>Ne rezervăm dreptul de a modifica acești termeni în orice moment. Vă recomandăm să verificați periodic această pagină.</p>

                <strong style={{ color: 'white', background: '#696969', padding: '3px', borderRadius: '5px', letterSpacing: '0.1rem' }}> 7. Contact</strong>
                <p style={{ color: 'white' }}>Pentru întrebări sau nelămuriri, ne puteți contacta la: <strong>infocodersro@gmail.com</strong> </p>
            </div>
        </>
    )
}

export default TermsAndConditions